export default __webpack_public_path__ + "static/media/logo-alianca-write.671c4da4.svg";